// extracted by mini-css-extract-plugin
export default {"maincontainer":"ChatGbt_maincontainer__EwBS8"};